module.exports = __webpack_public_path__ + "assets/img/images_k.963bf9a0.png";